<div class="pop-modal-uploader" *ngIf="filesStatus?.length">
  <div class="pop-modal-header px-3" [attr.aria-expanded]="!isCollapsed">
    <span class="cursor-pointer" *ngIf="filesStatus?.length > 0" (click)="isCollapsed = !isCollapsed"> {{ filesStatus?.length }} uploads</span>
    <span class="action">
      <i
        class="ml-2 cursor-pointer pi {{ isCollapsed ? 'pi-angle-up' : 'pi-angle-down' }}"
        (click)="isCollapsed = !isCollapsed"
        aria-controls="collapseEvent"></i>
      <i class="ml-2 cursor-pointer pi pi-times f-12" (click)="filesStatus = []; isCollapsed = true"></i>
    </span>
  </div>
  <div class="pop-modal-content px-3" [isAnimated]="true" *ngIf="isCollapsed">
    <div class="d-flex align-items-center py-2" *ngFor="let file of filesStatus; let ind = index">
      <div class="text-elipsis text-overflow-hidden">
        {{ file?.name }}
      </div>
      <div class="progress-status ml-auto" *ngIf="file?.hasOwnProperty('percentage')">
        <div class="percent" *ngIf="file.percentage > 0 && file.percentage < 100">
          <svg>
            <circle cx="8" cy="10" r="9"></circle>
            <circle cx="8" cy="10" r="9" [style.stroke-dashoffset]="'calc(55 - (55 *' + file.percentage + ') / 100)'"></circle>
          </svg>
          <div class="number">
            <h2>{{ file.percentage }}</h2>
          </div>
        </div>
        <div class="d-flex" *ngIf="file.percentage == 100">
          <i class="pi pi-check ml-auto text-primary"></i>
        </div>
        <div class="d-flex" *ngIf="file.percentage == -1">
          <p class="ml-auto text-primary">Cancelled</p>
          <!-- <i class="pi pi-times ml-auto text-primary"></i> -->
        </div>
        <div class="spinner-container ml-auto" *ngIf="file.percentage == 0">
          <i class="pi pi-times text-primary cursor-pointer cancel-file" *ngIf="!file.drag" (click)="cancelImgUpload(file, ind)"></i>
          <div class="spinner" [style.transform]="'rotate(' + loadingPercentage + 'deg)'"></div>
        </div>
      </div>
    </div>
  </div>
</div>
